import { Reveal } from "./primitives";
import { SKILL_TRACKS, AI_TOOLS } from "@/data/content";
import { Sparkles, Check } from "lucide-react";

export const Skills = () => (
  <section id="skills" data-testid="skills-section" className="py-24 md:py-36 bg-[#101010] text-[#f5f3ef]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <span className="text-xs tracking-[0.22em] uppercase font-bold text-[#e24a29]">Skills</span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl leading-[1.02]">
          Three tracks. Pick the one you&apos;re hiring for.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {SKILL_TRACKS.map((t, i) => (
          <Reveal key={t.id} delay={i * 0.12}>
            <div
              data-testid={`skill-track-${t.id}`}
              className="h-full p-8 rounded-2xl border border-white/12 bg-white/[0.03] hover:bg-white/[0.06] hover:border-[#e24a29]/50 transition-all duration-300"
            >
              <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#e24a29]">{t.kicker}</span>
              <h3 className="mt-3 font-display text-3xl font-bold">{t.title}</h3>
              <p className="mt-3 text-[#a8a29e] leading-relaxed">{t.blurb}</p>
              <ul className="mt-6 space-y-3">
                {t.skills.map((s) => (
                  <li key={s} className="flex items-center gap-3 text-[#e7e5e4]">
                    <Check size={16} className="text-[#e24a29] shrink-0" />
                    <span className="text-sm font-medium">{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      {/* AI tools */}
      <Reveal delay={0.2}>
        <div className="mt-16 pt-10 border-t border-white/12">
          <div className="flex items-center gap-2 mb-6 text-[#a8a29e]">
            <Sparkles size={16} className="text-[#e24a29]" />
            <span className="text-xs tracking-[0.2em] uppercase font-bold">AI Tools I Use</span>
          </div>
          <div className="flex flex-wrap gap-3">
            {AI_TOOLS.map((tool) => (
              <span
                key={tool}
                data-testid={`ai-tool-${tool.toLowerCase().replace(/\s+/g, "-")}`}
                className="px-5 py-2.5 rounded-full border border-white/15 text-sm font-semibold hover:border-[#e24a29] hover:text-[#e24a29] hover:scale-105 transition-all duration-300 cursor-default"
              >
                {tool}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
